export interface KanbanViewHeaderI {
    title: string;
    name: string;
    total: string;
    position: number;
    duration: string;
    dropOff: string;
    dropOffHour: string;
}

export interface KanbanViewCardI {
    select: boolean;
    id: string;
    name: string;
    opportunityType: string;
    salesStage: string;
    amount: string;
    accountName: string;
    contactName: string;
    created: string,
    dateClosed: string,
    
}

export interface KanbanViewListI {
    id: string;                     
    header: KanbanViewHeaderI,
    cards: KanbanViewCardI[]; 
}
